import { GeoLocationModalMobile, LocationSearchField } from '../../../../../components/packages/GeoLocation';
import { useLocationSearchMobile } from '../../utils';
import { IGeoLocationContainerProps } from '../../types';

export function GeoLocationModalContainerMobile(props: IGeoLocationContainerProps) {
  const { isOpen, onClose, onSelectRegion, title } = props;

  const searchProps = useLocationSearchMobile();

  return (
    <GeoLocationModalMobile
      title={title}
      isError={searchProps.isError}
      isLoading={searchProps.isLoading}
      isOpen={isOpen}
      onClose={onClose}
      specialLocations={searchProps.specialLocations}
      locations={searchProps.locations}
      foundLocations={searchProps.foundLocations}
      isSearchShown={searchProps.isSearchShown}
      onLocationSelect={onSelectRegion}
      searchComponent={
        <LocationSearchField
          placeholder="Поиск"
          onChange={searchProps.onSearchValueChange}
          value={searchProps.searchValue}
        />
      }
      onRetry={searchProps.handleRetry}
    />
  );
}
